import React from 'react'
import { Item } from 'semantic-ui-react'



const MySideprojectList = (props)=>( 
  props.tab_sideproject_content.map((v,k)=>(
        <Item key={k}>
          <Item.Content>
            <Item.Header>{v.title}</Item.Header>
            <Item.Extra>{v.period}</Item.Extra>
            <Item.Description>
                {v.description}
            </Item.Description>
            <Item.Description>
                {v.status}
            </Item.Description>
            <Item.Description>
                {v.core}
            </Item.Description>
            <Item.Description>
                {v.company}
            </Item.Description>
            {v.result &&
                <Item.Description>
                    {v.result}
                </Item.Description>
            }
            {v.website &&
              <Item.Meta>{v.link}: <a rel="noopener noreferrer" target="_blank" href={v.website}>{v.website}</a></Item.Meta>
            }
            {v.proposal_url &&
              <Item.Meta>{v.proposal_lable}: <a rel="noopener noreferrer" target="_blank" href={v.proposal_url}>{v.proposal_title}</a></Item.Meta>
            }
          </Item.Content>
        </Item>
  ))
)

const TabExperienceContent = (props) => (
  <div className="tab-Experience-content">
    <Item.Group>
        <MySideprojectList  {...props}/>
    </Item.Group>
  </div>
)

export default TabExperienceContent


// WEBPACK FOOTER //
// ./src/components/TabSideprojectContent.js